import React from "react";
import { monthConverter } from "utils/common";
import { UserLevel } from "utils/constant";

const TableComponent = ({
  currentLevel,
  reportsData,
  tableRef,
  reportInfo,
}) => {
  let periodeName = "";
  if (reportInfo?.statusPeriode === "yearly") {
    periodeName = "Tahunan";
  } else {
    periodeName = "Bulanan";
  }

  const renderTableByLevel = () => {
    let dynamicCols = 0;

    if ([UserLevel.National].includes(currentLevel)) {
      dynamicCols += 1; // Kabupaten
    }

    if ([UserLevel.National, UserLevel.Province].includes(currentLevel)) {
      dynamicCols += 1; // Kabupaten
    }
    if ([UserLevel.Province, UserLevel.District].includes(currentLevel)) {
      dynamicCols += 1; // Puskesmas
    }
    if (
      [UserLevel.Province, UserLevel.District, UserLevel.Fasyankes].includes(
        currentLevel
      )
    ) {
      dynamicCols += 1; // Desa
    }

    const totalCols = 14 + dynamicCols;
    return (
      <>
        {" "}
        <thead>
          {currentLevel === UserLevel.National ? (
            <>
              <tr>
                <th rowSpan="2">No</th>
                <th rowSpan="2">Provinsi</th>
                <th rowSpan="2">Kabupaten</th>
                <th rowSpan="2">Jumlah Puskesmas Terdapat Kelompok MMP</th>
                <th rowSpan="2">
                  Jumlah Desa di Puskesmas Terdapat Kelompok MMP
                </th>
                <th colSpan="5">Jumlah Kelompok MMP Berdasarkan Jenis MMP</th>
                <th rowSpan="2">Jumlah Desa dengan Kader MMP</th>
                <th rowSpan="2">
                  Jumlah Desa yang Melakukan Distribusi Kelambu
                </th>
                <th rowSpan="2">
                  Jumlah Desa Melaksanakan KIE Terhadap Kelompok MMP
                </th>
                <th rowSpan="2">Jumlah Desa Melaksanakan MBS Rutin</th>
                <th rowSpan="2">
                  Jumlah Desa Melaksanakan pemantauan orang masuk (Skrining
                  Malaria)
                </th>
                <th rowSpan="2">
                  Jumlah Desa Melaksanakan pemantauan orang keluar (Skrining
                  Malaria)
                </th>
              </tr>
              <tr>
                <th>Pekerja Tambang</th>
                <th>Pekerja Hutan</th>
                <th>Pekerja Perkebunan</th>
                <th>Indigenous People/Suku Pedalaman</th>
                <th>Pendatang Sementara (TNI/POLRI/Pekerja Migran/Lainnya)</th>
              </tr>
            </>
          ) : (
            <tr>
              <th>No.</th>
              {[UserLevel.National, UserLevel.Province].includes(
                currentLevel
              ) && <th>Kabupaten</th>}

              {[
                UserLevel.National,
                UserLevel.Province,
                UserLevel.District,
              ].includes(currentLevel) && <th>Puskesmas</th>}

              {[
                UserLevel.National,
                UserLevel.Province,
                UserLevel.District,
                UserLevel.Fasyankes,
              ].includes(currentLevel) && <th>Desa</th>}

              <th>Dusun</th>
              <th>Jenis MMP</th>
              <th>Nama Ketua Kelompok</th>
              <th>Nomor Hp Ketua Kelompok</th>
              <th>Jumlah Anggota</th>
              <th>Jarak dari fasyankes terdekat (KM)</th>
              <th>Deskripsi Akses ke Fasyankes</th>
              <th>Apakah Tersedia Kader MMP</th>
              <th>Apakah dilakukan distribusi Kelambu</th>
              <th>Apakah dilaksanakan KIE</th>
              <th>Apakah dilaksanakan MBS Rutin</th>
              <th>
                Apakah dilakukan pemantauan orang masuk (Skrining Malaria)
              </th>
              <th>
                Apakah dilakukan pemantauan orang keluar (Skrining Malaria)
              </th>
            </tr>
          )}
        </thead>
        <tbody>
          {reportsData.length !== 0 ? (
            reportsData?.map((item, index) =>
              currentLevel === UserLevel.National ? (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item?.province_name}</td>
                  <td>{item?.district_name}</td>
                  <td>{item?.total_health_facilities_with_mmp_group}</td>
                  <td>
                    {item?.total_villages_with_mmp_group_in_health_facilities}
                  </td>
                  <td>{item?.mining_workers}</td>
                  <td>{item?.forest_workers}</td>
                  <td>{item?.plantation_workers}</td>
                  <th>{item?.indigenous_people}</th>
                  <th>{item?.temporary_migrants}</th>
                  <td>{item?.total_villages_with_mmp_cadres}</td>
                  <td>{item?.total_villages_with_net_distribution}</td>
                  <td>{item?.total_villages_with_kie}</td>
                  <td>{item?.total_villages_with_routine_mbs}</td>
                  <td>{item?.total_villages_with_inbound_screening}</td>
                  <td>{item?.total_villages_with_outbound_screening}</td>
                </tr>
              ) : (
                <>
                  <tr key={index}>
                    <td>{index + 1}</td>
                    {[UserLevel.National, UserLevel.Province].includes(
                      currentLevel
                    ) && <td>{item?.district_name}</td>}

                    {[UserLevel.Province, UserLevel.District].includes(
                      currentLevel
                    ) && <td>{item?.fasyankes_id?.split("|")[1]}</td>}

                    {[
                      UserLevel.Province,
                      UserLevel.District,
                      UserLevel.Fasyankes,
                    ].includes(currentLevel) && (
                      <td>{item?.urbanvillage_id?.split("|")[1]}</td>
                    )}

                    <td>{item?.sub_village}</td>
                    <td>{item?.mmp_type}</td>
                    <td>{item?.group_leader_name}</td>
                    <td>{item?.group_leader_contact}</td>
                    <td>{item?.total_group_member}</td>
                    <th>{item?.fasyankes_distance}</th>
                    <th>{item?.fasyankes_access_desc}</th>
                    <td>{item?.cadre_available}</td>
                    <td>{item?.net_gift}</td>
                    <td>{item?.kie}</td>
                    <td>{item?.routine_mbs}</td>
                    <td>{item?.in_person_monitoring}</td>
                    <td>{item?.out_person_monitoring}</td>
                  </tr>
                </>
              )
            )
          ) : (
            <tr>
              <td colSpan={totalCols}>Tidak Ada Data</td>
            </tr>
          )}
        </tbody>
      </>
    );
  };

  let levelName = "";
  if (currentLevel === UserLevel.National) {
    levelName = "Nasional";
  } else if (currentLevel === UserLevel.Province) {
    levelName = "Provinsi";
  } else if (currentLevel === UserLevel.District) {
    levelName = "Kabupaten/Kota";
  } else {
    levelName = "Fasyankes";
  }

  let data = reportInfo?.fasyankes;
  let parts = data?.split(",");
  let faskesName = parts?.map(function (part) {
    return part?.split("|")[1];
  });
  let result = faskesName?.join(", ");

  return (
    <div
      className="table-table-responsive"
      ref={tableRef}
    >
      <table>
        <tbody>
          <tr style={{ border: "none", padding: 0 }}>
            <th style={{ border: "none", paddingBottom: "0" }}>
              <h3>Laporan Rekap MMP</h3>
            </th>
          </tr>
        </tbody>
      </table>
      <table>
        <tbody>
          <tr style={{ border: "none" }}>
            <th
              width="200"
              style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}
            >
              Periode Laporan
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              : {periodeName}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Tahun
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              : {reportInfo?.periode?.year}
            </th>
          </tr>
          {reportInfo?.statusPeriode === "monthly" && (
            <tr style={{ border: "none" }}>
              <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
                Bulan
              </th>
              <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
                : {monthConverter(reportInfo?.periode?.month_start)} - {monthConverter(reportInfo?.periode?.month_end)}
              </th>
            </tr>
          )}
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Level
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              : {levelName}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Provinsi
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              :{" "}
              {!reportInfo?.province
                ? "Semua Provinsi"
                : reportInfo?.province?.split("|")[1]}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Kab/Kota
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              :{" "}
              {!reportInfo?.district
                ? "Semua Kab/Kota"
                : reportInfo?.district?.split("|")[1]}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0 }}>Fasyankes</th>
            <th style={{ border: "none", paddingTop: 0 }}>
              : {!reportInfo?.fasyankes ? "Semua Fasyankes" : result}
            </th>
          </tr>
        </tbody>
      </table>
      <table>{renderTableByLevel()}</table>
    </div>
  );
};

export default TableComponent;
